import {AuctionVehicleDetailResponseBody} from '../types';
import {normalizeAuctionVehicleCurrencies} from './normalizeAuctionVehicleCurrencies';

export function normalizeAuctionCurrencies(
  vehicle: AuctionVehicleDetailResponseBody
): AuctionVehicleDetailResponseBody {
  return {
    ...vehicle,
    auctionVehicle: normalizeAuctionVehicleCurrencies(vehicle.auctionVehicle),
  };
}
